module.exports = __webpack_public_path__ + "static/media/15c-03_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.b110a1a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15c/15c-03_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 165
// module chunks = 0